import { FunctionComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { IconDefinition, IconProp } from "@fortawesome/fontawesome-svg-core";

interface BrandsIconProps {
	icon: IconDefinition | IconProp;
	[unknownProp: string]: unknown;
}

export const BrandsIcon: FunctionComponent<BrandsIconProps> = ({ icon, ...rest }) => (
	<FontAwesomeIcon icon={icon} {...rest} />
);
